<template>
  <v-btn-toggle v-model="toggle" mandatory style="width: 100%">
    <v-btn
      v-for="item in items"
      :key="item.status"
      style="flex: 1"
      @click="setGroupExport(item.value)"
    >
      {{ item.text }}
    </v-btn>
  </v-btn-toggle>
</template>
<script>
export default {
  name: "components-backoffice-filters_global-groupExport",
  data: () => ({
    items: [],
    toggle: 0,
  }),

  computed: {
    exportState() {
      return this.$store.state.filters.groupExport.value;
    },
    thesePathsHideXLSX() {
      const paths = [
        "/reports/users",
        "/reports/sport",
        "/reports/deposits",
      ];

      let hide = false;

      paths.forEach((path) => {
        if (this.$route.path.includes(path)) {
          hide = true;
        }
      });

      return hide;      
    },
  },

  mounted() {
    // this.resetItems();
    this.changeItems();
  },

  watch: {
    exportState(val) {
      // Quando o valor de GroupExport é resetado no btn "Limpar"
      // Do componente Wrap, aqui é settado toggle = 0,
      // que corresponde ao value: ""
      if (val == false) {
        this.$store.commit("setGroupExport", "");
        this.toggle = 0;
      };
      // Esse tratamento é necessário para views que usam
      // paginação server-side e exportDoc
      if (val == "") this.toggle = 0;
    },
    $route(params) {
      params && this.changeItems();
    }
  },

  methods: {
    setGroupExport(value) {
      this.$store.commit("setGroupExport", value);
    },

    changeItems() {
      this.toggle = 0;

      if (this.thesePathsHideXLSX) {
        this.$store.commit("setGroupExport", "");
        this.toggle = 0;
        this.items = [
          { text: "Site", value: "" },
          { text: "CSV", value: "csv" },
        ];
      } else {
        this.$store.commit("setGroupExport", "");
        this.toggle = 0;
        this.items = [
          { text: "Site", value: "" },
          { text: "XLSX", value: "xlsx" },
          { text: "CSV", value: "csv" },
        ];
      }
    },

    resetItems() {
      this.$store.commit("setGroupExport", "");
      this.toggle = 0;
      this.items = [
        { text: "Site", value: "" },
        { text: "XLSX", value: "xlsx" },
        { text: "CSV", value: "csv" },
      ];
    }
  },
};
</script>
